import { render, staticRenderFns } from "./VircosModels.vue?vue&type=template&id=6c889e84&scoped=true&"
import script from "./VircosModels.vue?vue&type=script&lang=js&"
export * from "./VircosModels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c889e84",
  null
  
)

export default component.exports